import { AppBar, Toolbar, Typography, Container, Paper, IconButton } from '@mui/material';
import { IoMdArrowBack } from 'react-icons/io';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';

export default function PainManagement() {
  return (
    <div>
      <Navbar />

      <Container sx={{ paddingY: 4 }}>
        <Paper elevation={3} sx={{ padding: 3 }}>
            <Typography variant='p'>Coming Soon...</Typography>
        </Paper>
      </Container>
    </div>
  );
}
